import { TeaBlocksError } from './../../../TeaBlocksError';
import { ReturnBlock } from '../../ReturnBlock';
/**
 * Math subtraction block. Does inputs[0]-inputs[1]-inputs[2]-inputs[3]...
 */
export class SubtractBlock extends ReturnBlock {
    inputs;

    /**
     * Constructor
     * @param {ReturnBlock} inputs operands
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id)
        this.inputs = inputs;
    }

    /**
     * Evaluates the expression
     * @param {Map} varEnv variable environment
     * @returns left - (right_1 + right_2 + ...)
     */
    evalBlock(varEnv: Map<string, any>): number {
        let ans = Number(this.inputs[0].evalBlock(varEnv));
        if (isNaN(ans)) throw new TeaBlocksError("Input not a number", this.id);

        for (let op of this.inputs.slice(1)) {
            let val = Number(op.evalBlock(varEnv));
            if (isNaN(val)) throw new TeaBlocksError("Input not a number", this.id);
            ans -= val;
        }
        return ans;
    }
}
